import React from "react";
import css from "./CordovaVritraIntro.module.css";


export default function CordovaVritraIntro(props){
    const {}=props;
    return (
        <div className={`${css.cordovavritraintro} ${props.className||""}`}>
            <p className={css.text}>
                This package requires a cordova environment with the following plugins installed :
            </p>
            <ul className={css.list}>
                    {statics.plugins.map(name=><li key={name}>cordova-plugin-{name}</li>)}
            </ul>
            <p className={css.text}>This package supports only android and ios platforms</p>
        </div>
    )
}

const statics={
    plugins:["filepicker","media-capture","file"],
}
